module.exports = __webpack_public_path__ + "symantec_38x38.a2f9e8eecbe5bea6ba73c3a9eb87d65e.png";